<template>
  <div class="">
    <navbar />
    <div class="w-full">
    <section class="bg-white flex flex-row rounded px-8 pt-6 pb-8 mb-4">
      <div class="flex flex-col px-5">
        <div>
          <div class="flex flex-row flex-no-shrink flex-no-grow py-2">
            <h3 class="text-md"> Profile Picture </h3>
            <div class="db-file-upload ml-auto">
              <div class="file">
                <label class="file-label">
                  <input class="file-input" style="display:none" accept=".png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="myFiles" @change="changeProfileImage($event.target.files)">
                  <span alt="attach_file" class="py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs">Upload</span>
                </label>
              </div>
            </div>
          </div> 
          <div v-if="doctor.photo">
            <img :src="doctor.photo.url" class="w-64 h-64">
          </div>
          <div v-else>
            <i class="material-icons" style="font-size:250px">person</i>
          </div>
        </div>
        <div class="border border-b border-grey-lightest my-5"></div>
        <div>
          <div class="flex flex-row flex-no-shrink flex-no-grow py-2">
            <h3 class="text-md"> Signature </h3>
            <div class="db-file-upload ml-auto">
              <div class="file">
                <label class="file-label">
                  <input class="file-input" style="display:none" accept=".pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="myFiles" @change="changeSignatureImage($event.target.files)">
                  <span alt="attach_file" class="py-2 px-2 mr-1 justify-center cursor-pointer rounded-sm text-blue text-xs">Upload</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="doctor.signature">
            <img :src="doctor.signature.url" class="w-64 h-64">
          </div>
        </div>
      </div>
      <div class="w-1/2">
        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-semibold mb-2">Name</label>
          <input class="shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" @change="onName" :value="doctor.name"/>
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-semibold mb-2">Qualification</label>
          <input class="shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" @change="onQualification" :value="doctor.qualification" />
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-semibold mb-2">Summary</label>
          <input class="shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" @change="onDescription" :value="doctor.description"/>
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-semibold mb-2">Mobile Number</label>
          <input class="shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" @change="onMobileNumber" :value="doctor.mobile_number"/>
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-semibold mb-2">Registration Number</label>
          <input class="shadow appearance-none border border-grey-lightest rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" @change="onRegistrationNumber" :value="doctor.registration_number"/>
        </div>

        <button v-on:click="saveProfile" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Save</button>
      </div>
      <div class=" mt-4 mx-12">
          <div class="bg-white shadow-md rounded p-6">
            <div class="flex">
              <p class="text-grey-darker font-semibold text-base">
              Multi Factor Authentication
              </p>
            <span v-if="mfa.enabled" class="text-sm ml-12 bg-green-light rounded-full text-grey-dark py-2 font-semibold h-6 px-3 flex justify-center items-center gap-1">
              <span class="rounded-full mr-2 p-1 bg-green-dark"></span>
              enabled
            </span>
            <span v-else class="text-sm ml-12 bg-grey-lightest rounded-full text-grey-dark py-1.5 font-semibold px-3 h-6 flex justify-center items-center gap-1">
              <span class="rounded-full mr-1 p-1 bg-grey-dark"></span>
              disabled
            </span>
            </div>
            <p v-if="mfa.enabled" class="text-sm mt-1 mb-3 text-grey-dark">Enabled for your account</p>
            <p v-else class="text-sm mt-1 mb-3 text-grey-dark">Enable multi factor authentication</p>
            <!-- <button v-if="mfa.enabled" v-on:click="showOrClosePopup" class="bg-blue hover:bg-blue-dark text-white font-semibold mt-4 py-2 px-4 rounded focus:outline-none focus:shadow-outline">Disable MFA</button> -->
            <button v-if="!mfa.enabled" v-on:click="moveToMfaSettings" class="bg-blue hover:bg-blue-dark text-white font-semibold mt-4 py-2 px-4 rounded focus:outline-none focus:shadow-outline">Enable MFA</button>
          </div>
        </div>
    </section>
  </div>
  <div>
    <div v-if="isPopupVisible" class="popup">
      <div class="popup-content">
        <div class="flex">
          <p class="text-lg font-semibold text-grey-dark my-3 ml-6">Are you sure you want to disable MFA?</p>
          <div @click="showOrClosePopup" class="cursor-pointer text-xl ml-16 italic mb-6 text-grey-dark hover:text-blue hover:font-semibold">
            <i class="fa fa-window-close" aria-hidden="true"></i>    
          </div>              
        </div>
        <div class="flex items-center justify-between mt-4 mx-8">
            <button type="button" @click="disableMfaSettings" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              Yes
            </button>
            <div @click="showOrClosePopup" class="cursor-pointer text-base italic text-grey-dark hover:text-blue hover:font-semibold">
              <a href="#">No</a>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="toaster">
    <toaster/>
  </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Toaster from '@/components/common/Toaster'
import {mapGetters} from 'vuex'
import router from '../../router'
export default {
  components: {
    Navbar,
    Toaster
  },
  data () {
    return {
      doctorprofile: {photo: {}},
      languages: '',
      files: [],
      signature: null,
      profile: null,
      isLoading: false,
      isPopupVisible: false,
      mfa: {
        type: '',
        enabled: false
      }
    }
  },
  computed: {
    ...mapGetters({
      doctor: 'configuration/doctor'
    })
  },
  watch: {
    data () {
      this.fetchMfaStatus()
    }
  },
  mounted () {
    this.fetchMfaStatus()
  },
  methods: {
    saveProfile: function () {
      this.$store.dispatch('configuration/saveDoctorDetails', {profile: this.profile, signature: this.signature})
    },
    changeProfileImage: function (fileList) {
      let name = 'doc-' + fileList[0].name
      this.profile = new File([fileList[0]], name, { type: fileList[0].type })
      this.saveProfile()
    },
    changeSignatureImage: function (fileList) {
      let name = 'doc-' + fileList[0].name
      this.signature = new File([fileList[0]], name, { type: fileList[0].type })
      this.saveProfile()
    },
    moveToMfaSettings: function () {
      router.push('profile/mfa-account-settings')
    },
    fetchMfaStatus: function () {
      this.isLoading = true
      this.$http.get(window.API_URL + 'doctors/mfa_settings/new').then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.mfa.enabled = response.body.mfa_enabled
          this.mfa.type = response.body.mfa_type
        }
      }).catch(function () {
        this.isLoading = false
        this.$toast.open({
          message: 'Something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    },
    disableMfaSettings: function () {
      this.isLoading = true
      this.$http.delete(window.API_URL + 'doctors/mfa_settings').then(response => {
        if (response.status === 200) {
          this.isLoading = false
          this.mfa.enabled = false
          this.isPopupVisible = false
          this.$toast.open({
            message: response.body.message,
            type: 'success',
            position: 'top',
            queue: false
          })
        }
      }).catch(function () {
        this.isLoading = false
        this.isPopupVisible = false
        this.$toast.open({
          message: 'Something went wrong!',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    },
    showOrClosePopup () {
      this.isPopupVisible = !this.isPopupVisible
    },
    onName: function (event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', {name: event.target.value})
    },
    onDescription: function (event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', {description: event.target.value})
    },
    onQualification: function (event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', {qualification: event.target.value})
    },
    onMobileNumber: function (event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', {mobile_number: event.target.value})
    },
    onRegistrationNumber: function (event) {
      this.$store.dispatch('configuration/updateDoctorAttribute', {registration_number: event.target.value})
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Doctor/Profile.vue